import { observer } from 'mobx-react-lite';
import { EmployeesGraphicIcon } from '../../../../lib/icons';
import { useCreateBenefitSet } from '../hooks/useCreateBenefitSet';
import { useNavigate, useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Button } from '../../../../lib/components/atomic/button';
import { Typography } from '@mui/material';
import { useActions } from '../../../../hooks/useActions';
import { useGetBenefitSet } from '../../../../queries/benefit/benefitSet';

export const Conclusion = observer(() => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const { newBenefitSet } = useCreateBenefitSet();
  const { selectedEmployees } = useActions();

  const { data: benefitSet } = useGetBenefitSet(newBenefitSet.editingBenefitSetId);
  const isAssignment = location.pathname.includes('/assign_benefit_set');

  const getTitle = () => {
    if (isAssignment) {
      return t('benefitSet:assignmentSuccessful');
    }
    return newBenefitSet.editingBenefitSetId
      ? t('benefitSet:benefitSetUpdated')
      : t('benefitSet:benefitSetCreated');
  };

  const getSubtitle = () => {
    if (isAssignment) {
      return t('benefitSet:employeesUpdated');
    }
    return t('benefitSet:readyForAssignment', { name: newBenefitSet.name_de });
  };

  const getPrimaryButtonText = () => {
    if (isAssignment) {
      return t('common:SHOW_EMPLOYEES');
    }
    return t('custom:assignment_button');
  };

  const handlePrimaryButtonClick = async () => {
    if (newBenefitSet.assignmentContext == 'employeeDashboard') {
      newBenefitSet.clear();
      navigate(`/employees/${selectedEmployees}/dashboard`);
    } else if (isAssignment) {
      newBenefitSet.clear();
      navigate('/employees');
    } else {
      newBenefitSet.clear();
      newBenefitSet.loadBenefitSet(benefitSet);
      navigate('/actions/benefit-set/assign_benefit_set_to_employees/1');
    }
  };

  return (
    <div className="w-full h-full flex justify-center items-center">
      <div className="m-y-auto flex flex-col gap-y-8 items-center">
        <EmployeesGraphicIcon height={150} width={150} />
        <div className="flex flex-col gap-y-2 items-center">
          <Typography variant="h2" className="font-medium">
            {getTitle()}
          </Typography>
          <Typography className="text-grey-600">{getSubtitle()}</Typography>
        </div>
        <div className="flex flex-col gap-y-2 items-center">
          <Button onClick={handlePrimaryButtonClick}>{getPrimaryButtonText()}</Button>
          {!isAssignment && (
            <Button
              variant="tertiary"
              onClick={async () => {
                newBenefitSet.clear();
                navigate('/benefits/benefit-set');
              }}
            >
              {t('custom:to_overview')}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
});
